import { AssessmentResult } from '../../types/assessment';
import { ratingClass } from './scoreHelpers';
import TiCard from '../common/TiCard';

interface Props {
  result: AssessmentResult;
}

export default function RecommendationCard({ result }: Props) {
  const rc = ratingClass(result.rating);

  return (
    <TiCard label="Recommendation">
      <div className={`verdict-box verdict-${rc}`}>
        <div className={`verdict-title verdict-title-${rc}`}>{result.verdict.headline?.replace(/\bYELLOW\b/g, 'ORANGE')}</div>
        <div className={`verdict-body verdict-body-${rc}`}>{result.verdict.summary?.replace(/\bYELLOW\b/g, 'ORANGE')}</div>
      </div>
    </TiCard>
  );
}
